import { Component } from 'react'
import PropTypes from 'prop-types'
import { map, noop } from 'lodash-es'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import Tag from './tag'
import Button from '../Button'

const REVEAL_TAGS_IN_INCREMENTS_OF = 20

export default class Tags extends Component {
  constructor(props) {
    super(props)
    this.state = {
      maxVisibleTags: 4,
    }
  }

  handleAddTagClick = event => {
    event.preventDefault()
    this.revealAllTags()
    this.props.onClickAddTag()
  }

  handleShowMoreClick = event => {
    event.preventDefault()
    const maxVisibleTags = this.state.maxVisibleTags + REVEAL_TAGS_IN_INCREMENTS_OF
    this.setState({ maxVisibleTags })
  }

  revealAllTags() {
    const { tags } = this.props
    const maxVisibleTags = tags.length
    this.setState({ maxVisibleTags })
  }

  getTagsContent() {
    const { tags, showAddTag } = this.props
    const { maxVisibleTags } = this.state

    const numMore = tags.length - maxVisibleTags
    const tooManyTags = numMore > 0

    const visibleTags = tooManyTags ? tags.slice(0, maxVisibleTags) : tags

    let items = map(visibleTags, tag => {
      return (
        <CSSTransition key={`tag-${tag.name}`} classNames="fade-in-out" timeout={600}>
          <Tag path={tag.path} name={tag.name} />
        </CSSTransition>
      )
    })

    if (tooManyTags) {
      const nextShowIncrement = numMore > REVEAL_TAGS_IN_INCREMENTS_OF ? REVEAL_TAGS_IN_INCREMENTS_OF : numMore
      items.push(
        <CSSTransition key="show-more" classNames="fade-in-out" timeout={600}>
          <Button
            className="button-reset tag tag--is-square timeline-tags__more"
            title={`Show next ${nextShowIncrement} tags`}
            onClick={this.handleShowMoreClick}
          >
            +{numMore} more
          </Button>
        </CSSTransition>
      )
    }
    if (showAddTag) {
      items.push(
        <CSSTransition key="add-tag" classNames="fade-in-out" timeout={600}>
          <Button
            className="button-reset tag tag--is-square timeline-tags__add"
            title="Add timeline tags +"
            onClick={this.handleAddTagClick}
          >
            Add tags +
          </Button>
        </CSSTransition>
      )
    }
    return items
  }

  render() {
    const tags = this.getTagsContent()
    return (
      <TransitionGroup component="div" className="tags">
        {tags}
      </TransitionGroup>
    )
  }
}
Tags.propTypes = {
  tags: PropTypes.array,
  showAddTag: PropTypes.bool,
  onClickAddTag: PropTypes.func,
}
Tags.defaultProps = {
  tags: [],
  showAddTag: false,
  onClickAddTag: noop,
}
